import React from 'react'
import { CloseButton, HorizontalStack, Link } from '@ztechapps/webui.util'

export const ListRow = (props: Record<any, any>) => {
  const { _id, name, description, category, removeFavorite, onSelect } = props
  return (
    <tr>
      <td colSpan={2}>
        <HorizontalStack className="justify-content-between">
          <div>
            <Link
              onClick={async () => {
                await onSelect({ _id, name, category, description })
              }}
            >
              {name}
            </Link>
            <br />
            <small>{description}</small>
          </div>
          <CloseButton onClick={() => removeFavorite(_id)} />
        </HorizontalStack>
      </td>
    </tr>
  )
}
